import React from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
const BarChart = () => {
  const options = {
    responsive: true,
    scaleShowVerticalLines: false,
    scales: {
      x: {
        grid: {
          color: context => {
            if (context?.index === 0) {
              return 'rgba(142,142,142,0)'
            } else {
              return ''
            }
          },
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: false,
        text: 'Chart.js Bar Chart',
      },
    },
    barThickness: 38,
  }

  const labels = ['Jan', 'Feb', 'Mar', 'Aprl', 'May', 'Jun', 'Jul']

  const data = {
    labels,
    datasets: [
      {
        label: 'Report',
        data: [40, 30, 50, 12, 5, 25, 60],
        backgroundColor: '#3249D7',
      },
    ],
  }
  return <Bar height={80} options={options} data={data} />
}
export default BarChart
